import { useMutation } from '../../index';
import permissions from '../../Apollo/permissions';
import { validate } from 'parameter-validator';
import { query as Pipelines } from '../../pipelines/useQueryPipelines';
import { query as StagedRevisions } from '../../pipelines/staged-revisions/useQueryStagedRevisions';

import {
  mutation,
  buildVariables as buildUpdatePipelineIntegrationVariables,
} from './update-pipeline-integration-mutation-builder';

export default function useUpdatePipelineIntegration(options = {}) {
  const [executeMutation, response] = useMutation(mutation, {
    successMsg: 'Pipeline integration updated.',
    context: { permission: permissions.updatePipelineIntegration },
    ...options,
    refetchQueries: [
      {
        query: Pipelines,
        context: { permission: permissions.updatePipelineIntegration },
      },
      {
        query: StagedRevisions,
        context: { permission: permissions.updatePipelineIntegration },
      },
    ],
  });

  const updatePipelineIntegrationMutation = args => {
    const { stagedForDelete, consentCategoryId, consentMode } = args;

    const { pipelineIntegration, playbookId, pipelineVars, readyForDeploy, disabled } = validate(args, [
      'pipelineIntegration',
      'playbookId',
      'pipelineVars',
      'readyForDeploy',
      'disabled',
    ]);
    return executeMutation({
      variables: buildVariables({
        pipelineIntegration,
        playbookId,
        disabled,
        pipelineVars,
        readyForDeploy,
        stagedForDelete,
        consentCategoryId,
        consentMode,
      }),
    });
  };
  return [updatePipelineIntegrationMutation, response];
}

export function buildVariables({
  pipelineIntegration,
  playbookId,
  disabled,
  pipelineVars,
  readyForDeploy,
  stagedForDelete,
  consentCategoryId,
  consentMode,
}) {
  return buildUpdatePipelineIntegrationVariables({
    pipelineIntegration,
    playbookId,
    disabled,
    pipelineVars,
    readyForDeploy,
    stagedForDelete,
    consentCategoryId,
    consentMode,
  });
}
